/** Case request document upload rules (Create S5, View additional docs). */
export const CASE_DOC_MAX_BYTES = 10 * 1024 * 1024;
export const CASE_DOC_SIZE_LIMIT_LABEL = '10 MB';
export const CASE_DOC_ALLOWED_TYPES_LABEL = 'PDF, Excel (XLS/XLSX), Word (DOC/DOCX), PNG, or JPG';
export const CASE_DOC_ACCEPT =
  '.pdf,.xls,.xlsx,.doc,.docx,.png,.jpg,.jpeg,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/png,image/jpeg';

const ALLOWED_EXTENSIONS = new Set(['.pdf', '.xls', '.xlsx', '.doc', '.docx', '.png', '.jpg', '.jpeg']);
const ALLOWED_MIME_TYPES = new Set([
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/png',
  'image/jpeg',
]);

export const CASE_DOC_FILE_SIZE_ERROR = `The selected file exceeds the maximum upload size of ${CASE_DOC_SIZE_LIMIT_LABEL}.`;
export const CASE_DOC_FILE_TYPE_ERROR = `The selected file type is not supported. Please upload a ${CASE_DOC_ALLOWED_TYPES_LABEL} file.`;
export const CASE_DOC_DELETED_SUCCESS = 'Document deleted successfully.';

function fileExtension(name: string): string {
  const i = name.lastIndexOf('.');
  return i >= 0 ? name.slice(i).toLowerCase() : '';
}

const BLOCKED_EXTENSIONS = new Set(['.jfif']);

export function isAllowedCaseDocumentFile(file: File): boolean {
  const ext = fileExtension(file.name);
  if (ext && BLOCKED_EXTENSIONS.has(ext)) return false;
  if (ext && ALLOWED_EXTENSIONS.has(ext)) return true;
  const mime = file.type.trim().toLowerCase();
  if (mime === 'image/jfif' || mime === 'image/pjpeg') return false;
  return Boolean(mime && ALLOWED_MIME_TYPES.has(mime));
}

export function validateCaseDocumentFile(file: File): { ok: true } | { ok: false; message: string } {
  if (file.size > CASE_DOC_MAX_BYTES) {
    return { ok: false, message: CASE_DOC_FILE_SIZE_ERROR };
  }
  if (!isAllowedCaseDocumentFile(file)) {
    return { ok: false, message: CASE_DOC_FILE_TYPE_ERROR };
  }
  return { ok: true };
}
